import * as THREE from "three";

const resizeCanvas = (
  renderer: THREE.Renderer,
  camera: THREE.PerspectiveCamera
) => {
  renderer.domElement.width = window.innerWidth;
  renderer.domElement.height = window.innerHeight;
  // notify the renderer of the size change
  renderer.setSize(window.innerWidth, window.innerHeight);
  // update the camera
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
};

const resizeListener = (
  renderer: THREE.Renderer,
  camera: THREE.PerspectiveCamera
) => {
  // call and bind the resize event
  resizeCanvas(renderer, camera);
  window.addEventListener(
    "resize",
    () => resizeCanvas(renderer, camera),
    false
  );
  return {
    /**
     * Stop watching window resize
     */
    stop: () => {
      window.removeEventListener("resize", () =>
        resizeCanvas(renderer, camera)
      );
    },
  };
};

export { resizeCanvas, resizeListener };
